module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"searchChemicalsTitle":"Kemikalie information","myChemicalsTooltip":"Kemikalier tilmeldt mnavigator","myChemicals":"Mine kemikalier","noChemicalsFound":"Intet kemikalie fundet!","chemicalNameOrPartNumber":"Kemikalie navn eller part nr.","recentlyUpdated":"Nyeste Opdateret","searchResults":"Søgeresultater"}}')
  delete Component.options._Ctor
}
